module.exports = __webpack_public_path__ + "img/gear-loading.1da745db.svg";